export default "__VITE_ASSET__DBSba7uC__"